var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThickChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a66ad68b-cac6-4b8b-a790-5ab55f215040",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 695 436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "uuid-7788446f-a59e-4a0b-ad5b-73fc87a3cf0b",
    d: "m347.06.21c-18.33,0-35.84,7.65-48.3,21.12L17.63,325.06c-24.68,26.7-23.03,68.37,3.66,93.06,26.71,24.69,68.37,23.05,93.06-3.65l232.77-251.62,232.7,251.62c24.69,26.66,66.33,28.3,93.02,3.65,26.7-24.69,28.34-66.36,3.66-93.06L395.46,21.33C382.97,7.85,365.42.17,347.06.21Z",
    fill: "#1a8adb",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThickChevron);
export default __webpack_public_path__ + "static/media/thick-chevron.8ce0f3dba12c6536d92d5ff70d6fb18f.svg";
export { ForwardRef as ReactComponent };